import React from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

const ProgressIndicator = ({ personal, contacts, documents, membership }) => {
  const progressStyles = {
    personal: {
      path: { stroke: '#4CAF50' },
      text: { fill: '#2c3e50', fontSize: '24px' },
      trail: { stroke: '#e0e0e0' }
    },
    contacts: {
      path: { stroke: '#2196F3' },
      text: { fill: '#2c3e50', fontSize: '24px' },
      trail: { stroke: '#e0e0e0' }
    },
    documents: {
      path: { stroke: '#9C27B0' },
      text: { fill: '#2c3e50', fontSize: '24px' },
      trail: { stroke: '#e0e0e0' }
    },
    membership: {
      path: { stroke: '#FF9800' },
      text: { fill: '#2c3e50', fontSize: '24px' },
      trail: { stroke: '#e0e0e0' }
    }
  };

  return (
      <div className="progress-container">
        <div className="progress-item">
          <div className="progress-wrapper">
            <CircularProgressbar
                value={personal}
                text={`${personal}%`}
                styles={progressStyles.personal}
            />
          </div>
          <span className="progress-label">Личные данные</span>
        </div>

        <div className="progress-item">
          <div className="progress-wrapper">
            <CircularProgressbar
                value={contacts}
                text={`${contacts}%`}
                styles={progressStyles.contacts}
            />
          </div>
          <span className="progress-label">Контакты</span>
        </div>

        <div className="progress-item">
          <div className="progress-wrapper">
            <CircularProgressbar
                value={documents}
                text={`${documents}%`}
                styles={progressStyles.documents}
            />
          </div>
          <span className="progress-label">Документы</span>
        </div>

        <div className="progress-item">
          <div className="progress-wrapper">
            <CircularProgressbar
                value={membership}
                text={`${membership}%`}
                styles={progressStyles.membership}
            />
          </div>
          <span className="progress-label">Членство</span>
        </div>
      </div>
  );
};

export default ProgressIndicator;